import _ from "lodash";
import { useTranslation } from "react-i18next";

const NoInternet = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-1 flex-col justify-center items-center px-12">
      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M45.2247 13.3333C46.9847 15.6533 48.0007 18.3947 48.0007 21.3333C48.0007 24.272 46.9847 27.0133 45.2247 29.3333M18.774 13.3333C17.0167 15.6533 16.0007 18.3947 16.0007 21.3333C16.0007 24.272 17.0167 27.0133 18.7767 29.3333M54.1767 8C57.014 11.8133 58.6673 16.4 58.6673 21.3333C58.6673 26.2667 57.014 30.8533 54.1767 34.6667M9.82465 8C6.98732 11.8133 5.33398 16.4 5.33398 21.3333C5.33398 26.2667 6.98732 30.8533 9.82465 34.6667M29.334 26.6667L18.6673 56M45.334 56L34.6673 26.6667M22.6673 45.3333H41.334M37.334 21.3333C37.334 22.7478 36.7721 24.1044 35.7719 25.1046C34.7717 26.1048 33.4151 26.6667 32.0007 26.6667C30.5862 26.6667 29.2296 26.1048 28.2294 25.1046C27.2292 24.1044 26.6673 22.7478 26.6673 21.3333C26.6673 19.9188 27.2292 18.5623 28.2294 17.5621C29.2296 16.5619 30.5862 16 32.0007 16C33.4151 16 34.7717 16.5619 35.7719 17.5621C36.7721 18.5623 37.334 19.9188 37.334 21.3333Z"
          stroke="#BC0000"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <p className="font-custom font-bold text-xl mt-8">
        {t("lost_connection")}
      </p>
      <p className="font-custom font-medium text-sm mt-1 text-center">
        {t("no_connection")}
      </p>
      <button
        type="submit"
        className="mt-8 font-custom btn btn-block bg-primary text-white w-[128px] rounded-[30px] "
        onClick={() => {}}
      >
        {t("refresh")}
      </button>
    </div>
  );
};

export default NoInternet;
